import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
var GenericPageContainer = function GenericPageContainer(_ref) {
  var rendering = _ref.rendering;
  return /*#__PURE__*/React.createElement("div", {
    className: "module-group remove-padding-header"
  }, /*#__PURE__*/React.createElement(Placeholder, {
    name: "dot-generic-body",
    rendering: rendering
  }));
};
export default GenericPageContainer;